var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ag-grid-vue',{staticClass:"ag-theme-material",style:(_vm.style),attrs:{"grid-options":_vm.gridOptions,"column-defs":_vm.columnDefs},on:{"grid-ready":_vm.onGridReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }